"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var __exports_1 = require("../../../__exports");
/* istanbul ignore next */
var RadioIconSection = function (props) {
    return (React.createElement(__exports_1.default.RadioButton, { selectedValue: props.selectedValue, items: props.options || [], tag: 'p-icon-radio-button', onChange: props.onRadioButtonClick }, props.options &&
        props.options.map(function (option, index) {
            return (React.createElement(__exports_1.default.GridLayout, { key: option.toString() + 0 },
                React.createElement(__exports_1.default.GridCol, { key: option.toString() + 0 },
                    React.createElement(__exports_1.default.Panel, { key: option.toString() + 0, paddingRight: 'Small' },
                        React.createElement(__exports_1.default.IconGauge, { key: option.toString() + 0, gauge: option.iconValue, maxGauge: option.maxGauge || 0, title: option.iconTitle }))),
                React.createElement(__exports_1.default.GridCol, { key: option.toString() + 1, width: 'Auto' },
                    React.createElement(__exports_1.default.Text, { key: option.toString() + 0, text: option.text, mode: 'Inline', wrapMode: 'forcedWrap', weight: 'SemiBold' }))));
        })));
};
exports.default = RadioIconSection;
//# sourceMappingURL=RadioIconSection.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/filter-sections/build/control/components/RadioIconSection/RadioIconSection.js
// module id = 741
// module chunks = 0